
import {
  useGetProductsQuery,
  useGetProductByIdQuery,
  useSaveProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useBulkDeleteProductsMutation,
} from '../../baseApi';

// List hook (paginated)
export const useProductList = (pageNumber = 1, pageSize = 10, filters = {}) => {
  const payload = { pageNumber, pageSize, ...filters };
  return useGetProductsQuery(payload);
};

// Operations hook: create / update / delete / bulkDelete
export const useProductOperations = () => {
  const [saveProduct, { isLoading: saving, data: saveResult, error: saveError }] = useSaveProductMutation();
  const [updateProduct, { isLoading: updating, data: updateResult, error: updateError }] = useUpdateProductMutation();
  const [deleteProduct, { isLoading: deleting, data: deleteResult, error: deleteError }] = useDeleteProductMutation();
  const [bulkDeleteProducts, { isLoading: bulkDeleting, data: bulkDeleteResult, error: bulkDeleteError }] = useBulkDeleteProductsMutation();

  return {
    saveProduct,
    updateProduct,
    deleteProduct,
    bulkDeleteProducts,
    isProcessing: saving || updating || deleting || bulkDeleting,
    results: { saveResult, updateResult, deleteResult, bulkDeleteResult },
    errors: { saveError, updateError, deleteError, bulkDeleteError },
  };
};


// src/services/hooks/lifeInsurance/productMasterService.js
// import {
//   useGetProductsQuery,
//   useGetProductByIdQuery,
//   useSaveProductMutation,
//   useUpdateProductMutation,
//   useDeleteProductMutation,
//   useBulkDeleteProductsMutation,
// } from '../../baseApi';

// // List hook (paginated)
// // Returns the full RTK Query hook result so callers can do:
// // const { data, isLoading, error } = useProductList(1, 10, { searchValue: 'life' });
// export const useProductList = (pageNumber = 1, pageSize = 10, filters = {}) => {
//   // do not mutate input object
//   const payload = { pageNumber, pageSize, ...filters };

//   // explicit: if pageSize is 0, set fetchAll to true so backend uses FetchAll param
//   if (pageSize === 0 && payload.fetchAll === undefined) {
//     payload.fetchAll = true;
//   }

//   return useGetProductsQuery(payload);
// };

// // Operations hook: create / update / delete / bulkDelete
// export const useProductOperations = () => {
//   const [saveProduct, saveMeta] = useSaveProductMutation();
//   const [updateProduct, updateMeta] = useUpdateProductMutation();
//   const [deleteProduct, deleteMeta] = useDeleteProductMutation();
//   const [bulkDeleteProducts, bulkDeleteMeta] = useBulkDeleteProductsMutation();

//   const isProcessing = saveMeta.isLoading || updateMeta.isLoading || deleteMeta.isLoading || bulkDeleteMeta.isLoading;

//   return {
//     // mutation functions
//     saveProduct,
//     updateProduct,
//     deleteProduct,
//     bulkDeleteProducts,

//     // meta/results
//     meta: {
//       save: saveMeta,
//       update: updateMeta,
//       delete: deleteMeta,
//       bulkDelete: bulkDeleteMeta,
//     },

//     // convenience values
//     isProcessing,
//   };
// };

